import { queryCache, queryClient } from 'api'
import { UserInformationDTO } from 'api/services/User/types'
import { StoreSlice } from 'store'

export interface AuthSlice {
  locale: string
  setLocale: (value: string) => void
  accessToken: string | null
  refreshToken: string | null
  setAccessToken: (value: string | null) => void
  setRefreshToken: (value: string | null) => void
  isAuthenticated: boolean
  setIsAuthenticated: (arg: boolean) => void
  user: UserInformationDTO | null
  setUser: (value: UserInformationDTO | null) => void
  reset: () => void
}

export const authSlice: StoreSlice<AuthSlice> = (set, get) => ({
  locale: 'el',
  setLocale: (value) => {
    set({
      locale: value,
    })
  },
  accessToken: null,
  refreshToken: null,
  setAccessToken: (payload) =>
    set({
      accessToken: payload,
    }),
  setRefreshToken: (payload) =>
    set({
      refreshToken: payload,
    }),
  isAuthenticated: false,
  setIsAuthenticated: (payload) =>
    set({
      isAuthenticated: payload,
    }),
  user: null,
  setUser: (data) =>
    set({
      user: data,
    }),
  reset: () => {
    queryCache.clear()
    queryClient.cancelQueries()
    set({
      accessToken: null,
      refreshToken: null,
      isAuthenticated: false,
      user: null,
    })
  },
})
